import React, {lazy, useEffect, useMemo, useRef, useState} from 'react';
import {
    Btn,
    FlexColumnSection,
    FlexRowSection,
    SmallText,
    FlexDiv,
    ErrorText,
    EmptyFlexDiv
} from "../../styles/globalStyles";
import useScreenSize from "../../helpers/hooks/useScreenSize";
import styled from "styled-components";
import FormInput from "../../components/UI/FormInput";
import {t} from "i18next";
import {
    addClarityInfo,
    checkIfDateAfterToday,
    getLocationsForPurchase,
    isILPhone, isLocationIL,
    isUserFieldRequired
} from "../../helpers/functions";
import {
    LOGIN_MODAL,
    ONE_TIME_PASSWORD_MODAL,
    openModal,
    updateModalRes
} from "@arboxappv4/shared/src/redux/modalManagerSlice";
import {useDispatch, useSelector} from "react-redux";
import {Checkbox} from "antd";
import CustomSelect from "../../components/UI/CustomSelect";
import WhatsNextBox from "../../components/WhatsNextBox";
import {Colors} from '@arboxappv4/shared/src/styles/Colors'
import {apiAction} from "@arboxappv4/shared/src/helpers/HTTP";
import {setError, setLoadingType} from "@arboxappv4/shared/src/redux/siteSlice";
import {DB_DATE_FORMAT, LOADING_PAGE} from "@arboxappv4/shared/src/constants/constants";
import ReCAPTCHA from "react-google-recaptcha";
import dayjs from "dayjs";
import CustomFieldSwitcher from "../../components/UI/CustomFieldSwitcher";
import {customFieldFlowNames} from "@arboxappv4/shared/src/helpers/constants";
import {USER_SITE_FIELDS_SETTINGS} from "../../../../src/constants";
import CustomPhone from "../../components/UI/CustomPhone";
const CustomDatePicker = lazy(() => import(/* webpackChunkName: "CustomDatePicker" */'../../components/UI/CustomDatePicker'));

const PersonalDetails = (props) => {
    const { handleSubmit, values, errors, setFieldValue, touched, hideLocation, helperText, isInnerComponent, nextBtnText, validationSchema, cfFlowName, HPGroupId, isLead } = props;
    const box = useSelector(state => state.site.box)
    const selectedLocation = useSelector(state => state.site.selectedLocation)
    const oneTimePasswordModalRes = useSelector(state => state.modalManager[ONE_TIME_PASSWORD_MODAL].processRes)
    const [emailError, setEmailError] = useState(null);
    const [personalIdError, setPersonalIdError] = useState(null);
    const [phoneError, setPhoneError] = useState(null);
    const [isValidRecaptcha, setIsValidRecaptcha] = useState(process.env.NODE_ENV !== 'production');
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [leadMail, setLeadMail] = useState(null);
    const {isMobile} = useScreenSize()
    const dispatch = useDispatch()
    const recaptchaRef = useRef()

    const locations = useMemo(() => getLocationsForPurchase(true, HPGroupId),[box])
    const customFieldsDataPerLocation = useMemo(() => box?.locations_box?.find(location => location.id === values.locations_box_fk)?.custom_field, [values.locations_box_fk,box]);
    const userFieldSettings = useMemo(() => box?.boxes_settings?.find(setting => setting.prop_name === USER_SITE_FIELDS_SETTINGS)?.properties, [box])
    const allowPhoneVerify = useMemo(() => box?.boxes_settings?.some(setting => setting.prop_name === 'sitePhoneVerify' && setting.properties && setting.properties.active), [box])

    useEffect(() => {
        console.log('CF LOG 1', customFieldsDataPerLocation, values)
        const flowCustomFields = customFieldsDataPerLocation?.filter(cf => cf?.custom_field_flow.some(cf_flow => cf_flow.flow.name === (cfFlowName ?? customFieldFlowNames.USER)))
        console.log('CF LOG 2', flowCustomFields)
        const newFields = flowCustomFields?.map(field => {
            if(values.customFields) {
                const old = values.customFields.find(oldField => oldField.id === field.id)
                if (old) {
                    return {...field, value: old.value}
                }
            }
            return field;
        })
        console.log('CF LOG 3', newFields)
        setTimeout(() => setFieldValue('customFields', newFields),10);
    }, [customFieldsDataPerLocation]);

    useEffect(() => {
        if(locations && locations.length === 1 && Object.keys(values).length) {
            setFieldValue('locations_box_fk', locations[0].id)
        }
    }, [locations, values]);

    useEffect(() => {
        if(selectedLocation && locations && !values.locations_box_fk && !HPGroupId) {
            if(locations.some(location => location.id === selectedLocation.id)) {
                setFieldValue('locations_box_fk', selectedLocation.id)
            }
        }
    }, [selectedLocation, locations, values.locations_box_fk]);

    useEffect(() => {
        if(emailError) {
            setEmailError(null)
        }
    }, [values.email]);

    useEffect(() => {
        if(phoneError) {
            setPhoneError(null)
        }
    }, [values.phone]);

    useEffect(() => {
        if(personalIdError) {
            setPersonalIdError(null)
        }
    }, [values.personal_id]);

    useEffect(() => {
        if(oneTimePasswordModalRes && allowPhoneVerify) {
            setFieldValue('otp_id', oneTimePasswordModalRes)
            if(leadMail) {
                setFieldValue('email', leadMail)
            }
            dispatch(updateModalRes({modalName: ONE_TIME_PASSWORD_MODAL, res: null}))
            submitStep()
        }
    }, [oneTimePasswordModalRes]);

    const validateEmailAndSubmit = async () => {
        setSubmitted(true)
        try {
            setEmailError(errors.email)
            setPersonalIdError(errors.personal_id)
            setPhoneError(errors.phone)
            if ((values.email || values.phone) && Object.keys(errors).length === 0) {
                setLoading(true)
                const email = values.email.replace(' ', '')
                addClarityInfo('tag', "email", `${values.email}`)
                addClarityInfo('tag', "phone", `${values.phone}`)
                let allowedToConvert = !values.lead_id;
                if(values.lead_id) {
                    addClarityInfo('tag', "lead_id", `${values.lead_id}`)
                    allowedToConvert = await apiAction('checkConvertLeadMail', 'post', {email: email, user_id: values.lead_id});
                }
                if(!allowedToConvert) {
                    setEmailError(t('not-allowed-to-convert'))
                } else {
                    const phoneUserBoxes = await validatePhoneVerify()
                    const mailUserBoxes = email ? await apiAction(`site/register/mailExist`, 'post', {email: email, boxId: box?.id, personalId: values.personal_id}) : null;
                    if(mailUserBoxes?.email || mailUserBoxes?.personalId || phoneUserBoxes) {
                        const valid = await handleExisingUserBox(mailUserBoxes?.email, phoneUserBoxes, mailUserBoxes?.personalId)
                        if(valid) await openVerifyPhonePopup(true)
                    } else {
                        await openVerifyPhonePopup(true)
                    }
                }
                setLoading(false)
            } else { // there is an error, submit to show error (don't open verification popup yet)
                await submitStep()
            }
        } catch(error) {
            setLoading(false)
            console.log('error', error)
        }
    }

    const validatePhoneVerify = async () => {
        try {
            if(allowPhoneVerify && isILPhone(values.phone)) {
                return await apiAction(`validatePhoneVerify`, 'post', {phone: values.phone});
            }
            return null
        } catch (error) {
            console.log('error', error)
            setPhoneError(t(error.error?.messageToUser ?? 'phone-otp-error'))
            throw error
        }
    }

    const submitStep = async () => {
        if(process.env.NODE_ENV !== 'production') {
            handleSubmit()
        } else {
            if(isValidRecaptcha) handleSubmit()
            else {
                const token = await recaptchaRef.current?.executeAsync();
                const isValid = await apiAction(`register/validateRecaptcha`, 'post', {token});
                setIsValidRecaptcha(isValid)
                if (isValid) {
                    handleSubmit()
                } else {
                    dispatch(setError(t('register-recaptcha-error')))
                }
            }
        }
    }

    const handleExisingUserBox = async (mailUserData, phoneUserData, personalIdData) => {
        let valid = true;
        let mailLeadId = null
        let phoneUserId = null
        const checkPhone = !!(allowPhoneVerify && phoneUserData && isILPhone(values.phone))

        if(mailUserData?.isDeleted) {
            setEmailError(t('user-box-deleted'))
            valid = false
        } else {
            if(mailUserData?.isLeadInBox) {
                mailLeadId = mailUserData.userFk
            } else if(mailUserData?.isLeadInBox === false) {
                setEmailError(
                    <span>
                        <ErrorText>{t('user-box-exist')}. </ErrorText>
                        <LoginToContinue onClick={() => dispatch(openModal({modalName: LOGIN_MODAL, props: {email: values.email, mailOnly: true}}))}>{t('login-to-continue')}</LoginToContinue>
                    </span>
                )
                valid = false
            }
        }

        if(personalIdData) {
            setPersonalIdError(
                <span>
                    <ErrorText>{t('user-box-exist-personal-id')}. </ErrorText>
                </span>
            )
            valid = false
        }
        
        if(checkPhone) {
            if(phoneUserData.isDeleted) {
                setPhoneError(t('user-box-deleted'))
                valid = false
            } else {
                phoneUserId = phoneUserData.userFk
                if (phoneUserData.isLeadInBox === false ||
                    (phoneUserData.isLeadInBox && values.lead_id && phoneUserData.userFk !== values.lead_id)) // edge case #1- lead from convert link trying to sign up using phone of a different lead in box, should restrict
                {
                    setPhoneError(
                    <span>
                        <ErrorText>{t('user-box-exist-phone')}. </ErrorText>
                        <LoginToContinue onClick={() => openVerifyPhonePopup()}>{t('login-to-continue')}</LoginToContinue>
                    </span>
                    )
                    valid = false
                }
                //DONT TOUCH THIS CONDITION!
                // edge case #2- lead with no mail (not from convert link) and input mail is valid, should continue with lead_id
                if(phoneUserData.isLeadInBox && !mailUserData?.isLeadInBox && phoneUserData.email === null) {
                    //check new mail is eligible for conversion! (aka mail is not is use for a user other than phoneUserData.userFk)
                    const allowedToConvert = await apiAction('checkConvertLeadMail', 'post', {email: values.email, user_id: phoneUserData.userFk});
                    if(allowedToConvert) {
                        mailLeadId = phoneUserData.userFk
                    } else {
                        setPhoneError(t('phone-not-allowed-to-convert'))
                        valid = false
                    }
                }
                // edge case #3- lead with mail and input mail is optional and null, should continue with phone lead_id and save email in values after successful otp
                // relevant only if email in not a required field and phone verification in enabled!
                else if(phoneUserData.isLeadInBox && !mailUserData && phoneUserData.email) {
                    mailLeadId = phoneUserData.userFk
                    setLeadMail(phoneUserData.email)
                }
                // edge case #4- existing lead with no mail and input mail exists but to other lead, should restrict
                else if(phoneUserData.isLeadInBox && !phoneUserData.email && mailUserData?.isLeadInBox) {
                    if(phoneUserData.userFk !== mailUserData.userFk) {
                        setEmailError(t('lead-mail-mismatch-phone'))
                    }
                }
            }
        } else {
            phoneUserId = mailLeadId
        }

        if(mailLeadId && phoneUserId) { //phoneUserId is always set- when no verify check needed it's equal to mailLeadId, otherwise it the phoneUserData.userFk
            if(mailLeadId !== phoneUserId) {
                valid = false
            } else {
                setFieldValue('lead_id', mailLeadId)
            }
        }

        return valid
    }

    const openVerifyPhonePopup = async (isVerify = false) => {
        if(!allowPhoneVerify || !isILPhone(values.phone)) {
            await submitStep()
            return
        }
        try {
            dispatch(setLoadingType(LOADING_PAGE))
            const otpId = await apiAction(`mfa`, 'post', {type: 'sms', value: values.phone, isVerify, check_format: true});
            dispatch(openModal({
                modalName: ONE_TIME_PASSWORD_MODAL,
                props: {type: 'sms', phone: values.phone, otpId: otpId, standAlone: true, isVerify}
            }))
            dispatch(setLoadingType(null))
        } catch (error) {
            console.log('openVerifyPhonePopup error', error)
            dispatch(setLoadingType(null))
        }
    }

    const inputLabel = (name, label) => {
        if(validationSchema && validationSchema.fields[name] && !validationSchema.fields[name].spec.optional) {
            return `${label}*`
        } else if(isUserFieldRequired(userFieldSettings, name, isLead ? 'lead' : 'member', ['email','phone'].includes(name))) {
            return `${label}*`
        }
        return label
    }

    return (
        <FlexRowSection justify={'space-between'} gap={'40px'} height={'100%'} align={'start'}>
            <FlexColumnExtended gap={'20px'} isMobile={isMobile} height={'100%'} isInnerComponent={isInnerComponent}>
                <FlexColumnSection gap={'24px'} height={isMobile ? `calc(100% - ${25+38}px)` : 'auto'} overflow={'auto'} flex={1}>
                    <FlexDiv dir={isMobile ? 'column' : 'row'} gap={'20px'}>
                        <FormInput label={inputLabel('first_name', t('first-name'))} initValue={values.first_name} value={values.first_name} error={(submitted && errors.first_name) ? errors.first_name : null} onChangeCallback={(val) => setFieldValue('first_name', val)} autoComplete={'given-name'} id="firstName" flex={1}/>
                        <FormInput label={inputLabel('last_name', t('last-name'))} initValue={values.last_name} value={values.last_name} error={(submitted && errors.last_name) ? errors.last_name : null} onChangeCallback={(val) => setFieldValue('last_name', val)} autoComplete={'family-name'} id="lastName" flex={1}/>
                    </FlexDiv>
                    <FlexDiv dir={isMobile ? 'column' : 'row'} gap={'20px'}>
                        <FormInput label={inputLabel('email', t('email'))} disabled={!!values.otp_id} initValue={values.email} value={values.email} error={(submitted && errors.email) ? errors.email : emailError} onChangeCallback={(val) => setFieldValue('email', val)} type={'email'} autoComplete={'email'} inputMode={'email'} id={'email'} flex={1} />
                        <CustomPhone label={inputLabel('phone', t('phone'))} disabled={!!values.otp_id} value={values.phone} error={(submitted && errors.phone) ? errors.phone : phoneError} onChange={(val) => setFieldValue('phone', val)} country_code={selectedLocation?.country_code} flex={1}/>
                    </FlexDiv>
                    <FlexDiv dir={isMobile ? 'column' : 'row'} gap={'20px'}>
                        <FormInput label={inputLabel('birthday', t('birth-date'))} value={values.birthday} error={(submitted && errors.birthday) ? errors.birthday : null} flex={1} showOptional={true}>
                            <CustomDatePicker onDateSelect={(val) => setFieldValue('birthday', val)}
                                              disabledDate={checkIfDateAfterToday}
                                              validRange={[dayjs('1920-01-01',DB_DATE_FORMAT), dayjs()]}
                                              defaultDate={values.birthday}
                                              error={(submitted && errors.birthday) ? errors.birthday : null}
                            />
                        </FormInput>
                        <FormInput showOptional={true} label={inputLabel('gender', t('gender'))} value={values.gender} flex={1} error={(submitted && errors.gender) ? errors.gender : null}>
                            <CustomSelect allowClear filterSort={(a,b) => a - b} onChange={(val) => setFieldValue('gender', val)} options={[{ label: t('male'), value: 'male' }, { label: t('female'), value: 'female' }]} defaultValue={values.gender} placeholder={t('select')} error={(submitted && errors.gender) ? errors.gender : null}/>
                        </FormInput>
                    </FlexDiv>
                    <FlexDiv dir={isMobile ? 'column' : 'row'} gap={'20px'}>
                        {
                            'personal_id' in values && isLocationIL() &&
                            <FormInput label={inputLabel('personal_id', t('personal-id'))} value={values.personal_id} error={((submitted && errors.personal_id)) ? errors.personal_id : personalIdError} onChangeCallback={(val) => setFieldValue('personal_id', val)} type={'phone'} inputMode={'tel'} flex={1}/>
                        }
                        {
                            !hideLocation && locations && locations.length > 1 ?
                            <FormInput label={inputLabel('locations_box_fk', t('location'))} value={values.locations_box_fk} error={(submitted && errors.locations_box_fk) ? errors.locations_box_fk : null} flex={1}>
                                <CustomSelect onChange={(val) => setFieldValue('locations_box_fk', val)} options={locations} defaultValue={values.locations_box_fk}/>
                            </FormInput> : <EmptyFlexDiv />
                        }
                    </FlexDiv>
                    {values.customFields && <CustomFieldSwitcher data={values?.customFields} setFieldValue={setFieldValue} touched={touched} errors={errors} values={values}/> }
                    <FlexColumnSection gap={'10px'} flex={'none'}>
                        <Checkbox checked={values.allow_mailing_list === 'yes'} onChange={(val) => setFieldValue('allow_mailing_list', val.target.checked ? 'yes' : 'no')} style={{width: 'fit-content'}}>
                            <SmallText>{t('allow-mail')}</SmallText>
                        </Checkbox>
                        <Checkbox checked={values.allow_sms === 'yes'} onChange={(val) => setFieldValue('allow_sms', val.target.checked ? 'yes' : 'no')} style={{width: 'fit-content'}}>
                            <SmallText>{t('allow-sms')}</SmallText>
                        </Checkbox>
                    </FlexColumnSection>
                    <div>
                        <span style={{fontSize: '14px'}}>{t('agree-to')} </span>
                        <SmallTextUnderline fontSize={'14px'} onClick={() => window.open('https://www.arboxapp.com/terms-and-conditions', '_blank')}>{t('terms-of-Use')}</SmallTextUnderline>
                        <span style={{fontSize: '14px'}}> {t('acknowledge-and-read')} </span>
                        <SmallTextUnderline fontSize={'14px'} onClick={() => window.open('https://www.arboxapp.com/privacy-policy', '_blank')}>{t('privacy-policy')}</SmallTextUnderline>
                    </div>
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey={process.env.SITE_REGISTER_RECAPTCHA}
                        size="invisible"
                    />
                </FlexColumnSection>
                <FlexRowSection height={'38px'} flex={'none'} justify={'end'}>
                    <Btn type={'primary'} onClick={validateEmailAndSubmit} width={isMobile ? '100%' : null} loading={loading}>{nextBtnText ?? t('continue')}</Btn>
                </FlexRowSection>
            </FlexColumnExtended>
            {!isMobile && !isInnerComponent && <WhatsNextBox text={helperText ?? t('personal-details-whats-next')}/>}
        </FlexRowSection>

    );
};

export default PersonalDetails;

const FlexColumnExtended = styled(FlexColumnSection)`
    padding: ${({isMobile, isInnerComponent}) => isMobile ? '0 16px' : isInnerComponent ? '16px' : '20px'};
    background: ${({isMobile}) => isMobile ? 'none' : Colors.white};
    box-sizing: border-box;
    border-radius: 5px;
`;
const SmallTextUnderline = styled.span`
    text-decoration: underline;
    font-size: ${({fontSize}) => fontSize ?? '16px'};
    font-weight: 400;
    cursor: pointer;
`;

const LoginToContinue = styled(SmallTextUnderline)`
    font-size: 14px;
    color: ${Colors.siteBlack}
`